import React from 'react'
import { Route, IndexRedirect } from 'react-router'
import qs from 'qs'
import { CONTEXT_ROOT } from './utils'

import Root from './containers/root'
import App from './containers/app'
import Resume from './containers/resume'
import List from './containers/list'
import Reupload from './containers/reupload'
import EndOfTheRide from './containers/endOfTheRide'
import NotFound from './containers/notFound'

const routes = (
  <Route path={`${CONTEXT_ROOT}/`} component={Root}>
    <IndexRedirect to={`${CONTEXT_ROOT}/request/pos_azienda_easynolo`} />
    {/* <IndexRedirect to={`${CONTEXT_ROOT}/request/pos_azienda`} /> */}
    <Route path={`${CONTEXT_ROOT}/request`} component={Root}>
      <IndexRedirect to={`${CONTEXT_ROOT}/request/pos_azienda_easynolo`} />
      {/* <IndexRedirect to={`${CONTEXT_ROOT}/request/pos_azienda`} /> */}
    </Route>
    <Route
      path={`${CONTEXT_ROOT}/oauth-request/:flow/:target`}
      onEnter={(route, replace) => {
        const { location: { query } } = route
        const newQuery = {
          ...query,
          embedded: route.params.target === 'embedded' ? '1' : undefined
        }
        replace(
          `${CONTEXT_ROOT}/request/${route.params.flow}${qs.stringify(
            newQuery,
            { addQueryPrefix: true }
          )}`
        )
      }}
    />
    <Route path={`${CONTEXT_ROOT}/request/:flow`} component={App} />
    <Route path={`${CONTEXT_ROOT}/request/:flow/:stepSlug`} component={App} />
    <Route path={`${CONTEXT_ROOT}/resume`} component={Resume}>
      <IndexRedirect to={`${CONTEXT_ROOT}/resume/pos_azienda_easynolo`} />
      {/* <IndexRedirect to={`${CONTEXT_ROOT}/resume/pos_azienda`} /> */}
    </Route>
    <Route path={`${CONTEXT_ROOT}/resume/:flow`} component={Resume} />
    <Route path={`${CONTEXT_ROOT}/resume/:flow/:guid`} component={Resume} />
    <Route path={`${CONTEXT_ROOT}/status`} component={List}>
      <IndexRedirect to={`${CONTEXT_ROOT}/status/pos_azienda_easynolo`} />
      {/* <IndexRedirect to={`${CONTEXT_ROOT}/status/pos_azienda`} /> */}
    </Route>
    <Route path={`${CONTEXT_ROOT}/status/:flow`} component={List} />
    <Route path={`${CONTEXT_ROOT}/reupload/:flow/:guid`} component={Reupload} />
    <Route path={`${CONTEXT_ROOT}/thanks/:flow`} component={EndOfTheRide} />
    <Route
      path={`${CONTEXT_ROOT}/thanks/:flow/:guid`}
      component={EndOfTheRide}
    />
    <Route path={`${CONTEXT_ROOT}/pending/:flow`} component={EndOfTheRide} />
    <Route path="*" component={NotFound} />
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./routes.js